// // // src/components/GoToPremiumDesktop.jsx
// import { useContext, useEffect, useState } from "react";
// import { doc, getDoc } from "firebase/firestore";
// import { db } from "../firebase";
// import { useAuth } from "../context/AuthContext";
// import { LanguageContext } from "../context/LanguageContext";
// import LeftMenu from "./menus/LeftMenu";
// import HeaderBar from "./headers/HeaderBar";
// import {
//   Box,
//   Button,
//   Container,
//   Grid,
//   List,
//   ListItem,
//   ListItemText,
//   Paper,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";

// // Stripe payments SDK
// import { getApp } from "firebase/app";
// import {
//   getStripePayments,
//   getCurrentUserSubscriptions,
//   createCheckoutSession,
//   getProducts,
// } from "@invertase/firestore-stripe-payments";

// const app = getApp();
// const payments = getStripePayments(app, {
//   productsCollection: "products",
//   customersCollection: "customers",
// });

// export default function GoToPremiumDesktop() {
//   const theme = useTheme();
//   const { translate } = useContext(LanguageContext);
//   const { currentUser } = useAuth();

//   const [role, setRole] = useState("Normal User");
//   const [subscriptions, setSubscriptions] = useState([]);
//   const [subsLoading, setSubsLoading] = useState(true);
//   const [checkoutLoading, setCheckoutLoading] = useState(false);

//   // (facultatif) si tu veux afficher les prix depuis Firestore
//   useEffect(() => {
//     getProducts(payments, { includePrices: true, activeOnly: true }).catch(
//       () => {}
//     );
//   }, []);

//   useEffect(() => {
//     if (!currentUser) return;
//     getDoc(doc(db, "profilsUsers", currentUser.uid))
//       .then((snap) => snap.exists() && setRole(snap.data().role || "Normal User"))
//       .catch(() => setRole("Normal User"));
//   }, [currentUser]);

//   useEffect(() => {
//     if (!currentUser) return;
//     getCurrentUserSubscriptions(payments, { status: "active" })
//       .then((subs) => setSubscriptions(subs))
//       .finally(() => setSubsLoading(false));
//   }, [currentUser]);

//   const handleSubscribe = async (priceId) => {
//     setCheckoutLoading(true);
//     try {
//       const session = await createCheckoutSession(payments, {
//         price: priceId,
//         success_url: `${window.location.origin}/app/gotopremium/success`,
//         cancel_url: `${window.location.origin}/app/gotopremium/cancel`,
//       });
//       window.location.assign(session.url);
//     } catch (e) {
//       setCheckoutLoading(false);
//     }
//   };

//   const tiers = [
//     {
//       nameKey: "TierFreeName",
//       priceKey: "TierFreePrice",
//       featureKeys: [
//         "TierFreeFeature1",
//         "TierFreeFeature2",
//         "TierFreeFeature3",
//         "TierFreeFeature4",
//       ],
//       buttonKey: "TierFreeButton",
//       buttonVariant: "outlined",
//     },
//     {
//       nameKey: "TierPremiumName",
//       priceKey: "TierPremiumPrice",
//       featureKeys: [
//         "TierPremiumFeature1",
//         "TierPremiumFeature2",
//         "TierPremiumFeature3",
//         "TierPremiumFeature4",
//         "TierPremiumFeature5",
//       ],
//       buttonKey: "TierPremiumButton",
//       buttonVariant: "contained",
//       priceId: "price_1S5t3VKxPduZsYMSfkEnFhpC", // ← ton price Stripe
//     },
//   ];

//   const hasActive = subscriptions.length > 0;

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         width: "100%",
//         bgcolor: "background.default",
//         color: "text.primary",
//         minHeight: "100vh",
//       }}
//     >
//       <LeftMenu />
//       <Box sx={{ width: "90%", ml: 1 }}>
//         <HeaderBar
//           title={translate("SupportTickets")}
//           subtitle={translate("PleaseSendTicket")}
//           showProjectSelect={false}
//           userName={currentUser?.displayName}
//           userRole={role}
//         />

//         <Box sx={{ px: { xs: 2, md: 3 }, pb: 6 }}>
//           <Container maxWidth="lg" sx={{ pt: 6 }}>
//             <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
//               {translate("PricingTitle")}
//             </Typography>
//             <Typography
//               variant="subtitle1"
//               align="center"
//               color="text.secondary"
//               gutterBottom
//             >
//               {translate("PricingSubtitle")}
//             </Typography>

//             <Grid container spacing={4} sx={{ mt: 4, justifyContent: "center" }}>
//               {tiers.map((t) => {
//                 const isPremiumTier = t.nameKey === "TierPremiumName";
//                 const isSelected = hasActive
//                   ? isPremiumTier
//                   : t.nameKey === "TierFreeName";

//                 return (
//                   <Grid key={t.nameKey} item xs={12} md={6}>
//                     <Paper
//                       sx={{
//                         p: 4,
//                         borderRadius: 2,
//                         textAlign: "center",
//                         bgcolor: "background.paper",
//                         boxShadow: isPremiumTier
//                           ? theme.palette.mode === "dark"
//                             ? "none"
//                             : "0px 10px 30px rgba(0,0,0,0.1)"
//                           : "none",
//                         border: "1px solid",
//                         borderColor: isSelected ? "primary.main" : "divider",
//                       }}
//                     >
//                       <Typography variant="h6" fontWeight={600}>
//                         {translate(t.nameKey)}
//                       </Typography>

//                       <Typography variant="h3" color="primary" sx={{ my: 2 }}>
//                         ${translate(t.priceKey)}
//                         {translate(t.priceKey) !== "0" && (
//                           <Typography component="span" fontSize="1.2rem">
//                             /mo
//                           </Typography>
//                         )}
//                       </Typography>

//                       <List dense sx={{ textAlign: "left" }}>
//                         {t.featureKeys.map((fk) => (
//                           <ListItem key={fk}>
//                             <ListItemText
//                               primary={translate(fk)}
//                               primaryTypographyProps={{ color: "text.primary" }}
//                             />
//                           </ListItem>
//                         ))}
//                       </List>

//                       {isPremiumTier ? (
//                         <Button
//                           variant="contained"
//                           size="large"
//                           disabled={checkoutLoading || subsLoading || hasActive}
//                           onClick={() => !hasActive && handleSubscribe(t.priceId)}
//                           sx={{
//                             mt: 3,
//                             textTransform: "none",
//                             ...(checkoutLoading || hasActive
//                               ? { border: "1px solid", borderColor: "divider" }
//                               : {}),
//                           }}
//                         >
//                           {checkoutLoading ? (
//                             <CircularProgress size={20} />
//                           ) : hasActive ? (
//                             translate("AlreadyPremium")
//                           ) : (
//                             translate(t.buttonKey)
//                           )}
//                         </Button>
//                       ) : (
//                         <Button variant="outlined" size="large" sx={{ mt: 3 }} disabled>
//                           {translate("Included")}
//                         </Button>
//                       )}
//                     </Paper>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </Container>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// src/components/GoToPremiumDesktop.jsx
import { useContext, useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { LanguageContext } from "../context/LanguageContext";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import {
  Box,
  Button,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Stripe payments SDK
import { getApp } from "firebase/app";
import {
  getStripePayments,
  getCurrentUserSubscriptions,
  createCheckoutSession,
  getProducts,
} from "@invertase/firestore-stripe-payments";

const app = getApp();
const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "customers",
});

export default function GoToPremiumDesktop() {
  const theme = useTheme();
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();

  const [role, setRole] = useState("Normal User");
  const [subscriptions, setSubscriptions] = useState([]);
  const [subsLoading, setSubsLoading] = useState(true);
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  // (facultatif) si tu veux afficher les prix depuis Firestore
  useEffect(() => {
    getProducts(payments, { includePrices: true, activeOnly: true }).catch(
      () => {}
    );
  }, []);

  useEffect(() => {
    if (!currentUser) return;
    getDoc(doc(db, "profilsUsers", currentUser.uid))
      .then(
        (snap) => snap.exists() && setRole(snap.data().role || "Normal User")
      )
      .catch(() => setRole("Normal User"));
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser) return;
    getCurrentUserSubscriptions(payments, { status: "active" })
      .then((subs) => setSubscriptions(subs))
      .finally(() => setSubsLoading(false));
  }, [currentUser]);

  const handleSubscribe = async (priceId) => {
    setCheckoutLoading(true);
    try {
      const session = await createCheckoutSession(payments, {
        price: priceId,
        success_url: `${window.location.origin}/app/gotopremium/success`,
        cancel_url: `${window.location.origin}/app/gotopremium/cancel`,
      });
      window.location.assign(session.url);
    } catch (e) {
      setCheckoutLoading(false);
    }
  };

  const tiers = [
    {
      nameKey: "TierFreeName",
      priceKey: "TierFreePrice",
      featureKeys: [
        "TierFreeFeature1",
        "TierFreeFeature2",
        "TierFreeFeature3",
        "TierFreeFeature4",
      ],
      buttonKey: "TierFreeButton",
      buttonVariant: "outlined",
    },
    {
      nameKey: "TierPremiumName",
      priceKey: "TierPremiumPrice",
      featureKeys: [
        "TierPremiumFeature1",
        "TierPremiumFeature2",
        "TierPremiumFeature3",
        "TierPremiumFeature4",
        "TierPremiumFeature5",
      ],
      buttonKey: "TierPremiumButton",
      buttonVariant: "contained",
      priceId: "price_1S5t3VKxPduZsYMSfkEnFhpC", // ← ton price Stripe
    },
  ];

  const hasActive = subscriptions.length > 0;

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      <LeftMenu />
      <Box sx={{ width: "90%", ml: 1 }}>
        <HeaderBar
          title={translate("SupportTickets")}
          subtitle={translate("PleaseSendTicket")}
          showProjectSelect={false}
          userName={currentUser?.displayName}
          userRole={role}
        />

        <Box sx={{ px: { xs: 2, md: 3 }, pb: 6 }}>
          <Container maxWidth="lg" sx={{ pt: 6 }}>
            <Typography
              variant="h4"
              fontWeight={700}
              align="center"
              gutterBottom
            >
              {translate("PricingTitle")}
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="text.secondary"
              gutterBottom
            >
              {translate("PricingSubtitle")}
            </Typography>

            <Grid
              container
              spacing={4}
              sx={{ mt: 4, justifyContent: "center" }}
            >
              {tiers.map((t) => {
                const isPremiumTier = t.nameKey === "TierPremiumName";
                const isSelected = hasActive
                  ? isPremiumTier
                  : t.nameKey === "TierFreeName";

                return (
                  <Grid key={t.nameKey} item xs={12} md={6}>
                    <Paper
                      sx={{
                        p: 4,
                        borderRadius: 2,
                        textAlign: "center",
                        bgcolor: "background.paper",
                        boxShadow: isPremiumTier
                          ? theme.palette.mode === "dark"
                            ? "none"
                            : "0px 10px 30px rgba(0,0,0,0.1)"
                          : "none",
                        border: "1px solid",
                        borderColor: isSelected ? "primary.main" : "divider",
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        {translate(t.nameKey)}
                      </Typography>

                      <Typography variant="h3" color="primary" sx={{ my: 2 }}>
                        ${translate(t.priceKey)}
                        {translate(t.priceKey) !== "0" && (
                          <Typography component="span" fontSize="1.2rem">
                            /mo
                          </Typography>
                        )}
                      </Typography>

                      <List dense sx={{ textAlign: "left" }}>
                        {t.featureKeys.map((fk) => (
                          <ListItem key={fk}>
                            <ListItemText
                              primary={translate(fk)}
                              primaryTypographyProps={{ color: "text.primary" }}
                            />
                          </ListItem>
                        ))}
                      </List>

                      {isPremiumTier ? (
                        <Button
                          variant="contained"
                          size="large"
                          disabled={checkoutLoading || subsLoading || hasActive}
                          onClick={() =>
                            !hasActive && handleSubscribe(t.priceId)
                          }
                          sx={{
                            mt: 3,
                            textTransform: "none",
                            ...(checkoutLoading || hasActive
                              ? { border: "1px solid", borderColor: "divider" }
                              : {}),
                          }}
                        >
                          {checkoutLoading ? (
                            <CircularProgress size={20} />
                          ) : hasActive ? (
                            translate("AlreadyPremium")
                          ) : (
                            translate(t.buttonKey)
                          )}
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          size="large"
                          sx={{ mt: 3 }}
                          disabled
                        >
                          {translate("Included")}
                        </Button>
                      )}
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
